"use client";

import { ShieldCheck, Network, Zap, Lock } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RemoteTeamVPNOptimization() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: stepsRef,
    isVisible: stepsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const steps = [{
    Icon: ShieldCheck,
    number: "01 / SECURE",
    title: "Unified encryption",
    description: "Deploy enterprise-grade protocols across your entire remote workforce, ensuring every connection remains private and protected from external threats.",
    offset: false
  }, {
    Icon: Network,
    number: "02 / CONNECT",
    title: "Seamless access",
    description: "Enable your team to access internal resources from any location with low-latency tunnels that feel like they are in the office.",
    offset: true
  }, {
    Icon: Zap,
    number: "03 / OPTIMIZE",
    title: "Peak performance",
    description: "Our intelligent routing minimizes packet loss and jitter, keeping your team productive during high-bandwidth tasks and video calls.",
    offset: false
  }];
  return <section data-section-id="215" id="remoteteamvpnoptimization" className="relative bg-background text-foreground py-32 px-6 md:px-12 lg:px-20 overflow-hidden">
      {}
      <div aria-hidden="true" className="absolute top-12 right-8 md:right-16 opacity-20 pointer-events-none">
        <Lock className="text-primary" style={{
        width: "120px",
        height: "120px",
        transform: "rotate(35deg)",
        strokeWidth: 0.6
      }} />
      </div>

      <div className="max-w-7xl mx-auto relative">
        {}
        <div ref={headerRef} className={`mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs tracking-[0.3em] text-secondary text-center mb-8 uppercase">
            Our Strategy
          </p>
          <h2 className="font-default text-5xl md:text-6xl lg:text-7xl text-foreground leading-[1.05] tracking-tight max-w-4xl">
            <span className="block italic font-light">Secure remote</span>
            <span className="block pl-8 md:pl-24 lg:pl-32 text-muted-foreground/80">
              team operations.
            </span>
          </h2>
        </div>

        {}
        <div ref={stepsRef} className="grid grid-cols-1 md:grid-cols-3 gap-y-16 md:gap-y-0 md:gap-x-0 relative">
          {steps.map((step, i) => {
          const Icon = step.Icon;
          return <div data-index={i} key={i} className={`group relative px-2 md:px-10 lg:px-12 transition-all duration-700 ease-out ${stepsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${step.offset ? "md:mt-12 lg:mt-16" : ""}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                {}
                {i > 0 && <span aria-hidden="true" className="hidden md:block absolute left-0 top-4 bottom-4 w-px bg-border" />}
                {}
                {i > 0 && <span aria-hidden="true" className="md:hidden absolute -top-8 left-1/4 right-1/4 h-px bg-border" />}

                {}
                <div className="mb-10">
                  <Icon className="text-muted-foreground transition-all duration-500 ease-out group-hover:scale-105 group-hover:text-primary" style={{
                width: "64px",
                height: "64px",
                strokeWidth: 0.9
              }} aria-hidden="true" />
                </div>

                {}
                <p className="font-mono text-[0.7rem] tracking-[0.25em] text-secondary uppercase mb-6">
                  {step.number}
                </p>

                {}
                <h3 className="font-default text-2xl md:text-[1.625rem] text-foreground leading-tight mb-5 italic font-light">
                  {step.title}
                </h3>

                {}
                <p className="font-default text-base text-muted-foreground leading-relaxed max-w-xs">
                  {step.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}